import React from "react";
import { ToogleDescription } from "../../components/toggleDescComp/ToogleDescription";

//imagenes
import secMantenimiento from "../../images/servicios/sec_mantenimiento.png";
import mantenimiento from "../../images/servicios/mantenimiento.png";
import ServiceTop from "../../components/layouts/ServiceTop";
import { MantenimientoU } from "../../utils/itemsToogle";
import BotonContactar from "../../components/layouts/boton/BotonContactar";

export default function Mantenimiento() {
  return (
    <>
      <ServiceTop
        image={mantenimiento}
        text={`Cualquiera de nuestras opciones de mantenimiento tendrá la
        finalidad de permitir que el equipo se encuentre listo para entrar
        en operación en cualquier momento y obtener niveles de suma
        confiabilidad, por medio de la certeza de que se encuentra en
        condiciones óptimas para su operación.`}
        title="Mantenimiento"
        secImage={secMantenimiento}
      />
      <ToogleDescription itemsToggle={MantenimientoU} />
      <BotonContactar />
    </>
  );
}
